
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type ExploreContentItemContentOneOfThreesevenMediaLinksItemLinkType = typeof ExploreContentItemContentOneOfThreesevenMediaLinksItemLinkType[keyof typeof ExploreContentItemContentOneOfThreesevenMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExploreContentItemContentOneOfThreesevenMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
